import Vue from 'vue';
import App from './App.vue'
import router from './router'
import './router/hook'
import store from './store'
import mixinData from './data/mixinData'
import protoData from './data/protoData'
// 公用函数
import common from './common.js'
// ElementUI
import ElementUI from 'element-ui'
import '@/assets/scss/element-variables.scss'
// 国际化
import i18n from './lang'
import "@/assets/less/base.less"

// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart, LineChart, PieChart, MapChart, RadarChart, SankeyChart, TreeChart } from "echarts/charts";
// 引入提示框，标题，直角坐标系组件，组件后缀都为 Component
import {
	TitleComponent,
	TooltipComponent,
	GridComponent,
	ToolboxComponent,
	LegendComponent,
	VisualMapComponent,
} from "echarts/components";
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from "echarts/renderers";
import vueEcharts from "vue-echarts";
// 批量注册基础组件
import './components/common';

// 注册必须的组件
echarts.use([
	TitleComponent,
	TooltipComponent,
	GridComponent,
	ToolboxComponent,
	LegendComponent,
	VisualMapComponent,
	BarChart,
	LineChart,
	PieChart,
	MapChart,
	RadarChart,
	SankeyChart,
	CanvasRenderer,
	TreeChart,
]);

Vue.component("v-chart", vueEcharts);

Vue.config.productionTip = false

Vue.prototype.$ELEMENT = { size: "medium", zIndex: 2000 }
Vue.prototype.$common = common;


Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
})

// 混入可观测的数据
Vue.mixin({
	data() {
		// 必须解构返回新对象，否则 vue-composition + vue-echarts 会影响所有 vue 实例
		// 此混入是在实例化每个组件的时候混入的，所以需要结构进入同一个对象
		return {
			...mixinData
		}
	},
	created() {
		if (process.env.NODE_ENV === 'development') {
			let name = this.$options.name;
			if (name) {
				if (this.$root[name]) {
					this.$root[name].push(this);
				} else {
					this.$root[name] = [this];
				}
			}

		}
	},
	beforeDestroy() {
		if (process.env.NODE_ENV === 'development') {
			let name = this.$options.name;
			if (name) {
				let index = this.$root[name].indexOf(this);
				if (index != -1) {
					this.$root[name].splice(index, 1);
				}
			}
		}
	}
})
// 附加其他数据
Object.assign(Vue.prototype, protoData)
export const eventBus = new Vue({});
const app = new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV === "development") {
	window.app = app;
} else {
	window.krk7jl7x = app;
}

